'use strict';

// Fixes https://github.com/motiondivision/motion/issues/2270
const getContextWindow = ({ current }) => {
    return current ? current.ownerDocument.defaultView : null;
};

exports.getContextWindow = getContextWindow;
//# sourceMappingURL=get-context-window.cjs.map
